import {
    CREATE_BRAND,
    CREATE_BRAND_FAILED,
    RESET_FORMS
} from '../actions/types'

const initialState = {}

const createBrandReducer = (state = initialState, action) => {
    switch(action.type){
        case CREATE_BRAND:
            return {
                details: action.payload,
                success: 'Brand created successfully',
            }
        case CREATE_BRAND_FAILED:
            return {
                ...state,
                errors: action.payload,
                success: null
            }
        case RESET_FORMS:
            return initialState
        default:
            return state
    }
}

export default createBrandReducer